import * as React from 'react';
import { ChevronRight } from 'react-feather';
import { matchPath, NavLink } from 'react-router-dom';
import styled from 'styled-components';
import { useRouter } from '../../hooks';
import { ThemeInterface } from '../../theme/ThemeInterface';
import { H4 } from '../../typography';

const StyledChevron = styled(ChevronRight)<any>`
  margin: 1px 3px 0 6px;
  color: ${(props: ThemeInterface) => props.theme.colors.white};
`;

const StyledLink = styled(NavLink)`
  display: flex;
  align-items: center;
  text-decoration: none;
  justify-content: center;
`;

export type BreadcrumbsArray = { title: string; path: string; key?: string }[];

type Props = {
  breadcrumbs: BreadcrumbsArray;
};

const Breadcrumbs = ({ breadcrumbs }: Props) => {
  const { match } = useRouter();
  return (
    <React.Fragment>
      {breadcrumbs.map((breadcrumb, index: number) => {
        const matched = matchPath(match.url, { path: breadcrumb.path });
        const url = matched === null || !matched.url ? breadcrumb.path : matched.url;
        return (
          <StyledLink key={breadcrumb.key ? breadcrumb.key : breadcrumb.title} to={url}>
            <H4>{breadcrumb.title}</H4>
            {index < breadcrumbs.length - 1 && <StyledChevron size={18} />}
          </StyledLink>
        );
      })}
    </React.Fragment>
  );
};

export default Breadcrumbs;
